var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"language"}},[_vm._v(" language设置 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }